export enum ELanguage {
  ENGLISH = 'en',
  GERMAN = 'de',
  FRENCH = 'fr',
  DUTCH = 'nl',
  SPANISH = 'es',
  TURKISH = 'tr',
}
// Type map of the values

export type TLanguage = `${ELanguage}`;
